module.exports = "btn-add-file {\n  margin-left: auto; }\n\n.file-label {\n  display: inline-block;\n  word-break: break-word;\n  border-radius: 0.25em;\n  background-color: #acacaf;\n  color: #fff;\n  padding: 0 5px;\n  font-weight: 600; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/sections/job-file-section/job-file-section.component.scss
// module id = ./web/modern/components/jobs/sections/job-file-section/job-file-section.component.scss
// module chunks = 0